<template>
  <div class="d-lg-flex">
    <div class="chat-leftsidebar mr-lg-4">
      <div class="chat-leftsidebar-nav">
        <b-card>
          <b-card-text>
            <div>
              <h5 class="font-size-14 mb-3">Timeline</h5>
              <simplebar
                style="max-height: 670px"
                id="chat-list"
                v-if="
                  value !== undefined &&
                  value.logs !== undefined &&
                  value.logs.length > 0
                "
              >
                <ul class="verti-timeline list-unstyled">
                  <template v-for="(item, index) in value.logs">
                    <li
                      class="event-list cursor-pointer bg-active-hover"
                      v-bind:key="index"
                      :class="defaultLog.id === item.id ? 'active' : ''"
                      @click="onChangeLogDetail(index)"
                    >
                      <!-- <a
                        href="#"
                        class="link-event-list"
                      > -->
                        <div class="event-timeline-dot">
                          <i
                            class="bx font-size-18"
                            :class="
                              defaultLog.id === item.id
                                ? 'bxs-right-arrow-circle bx-fade-right'
                                : 'bx-right-arrow-circle'
                            "
                          ></i>
                        </div>
                        <div class="media">
                          <div class="mr-3">
                            <h5 class="font-size-14">
                              {{ getDateStr(item.create_info.time_stamp) }}
                              <i
                                class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                              ></i>
                            </h5>
                            <div
                              class="avatar-xs align-self-center mr-3"
                              v-if="
                                item.create_info !== undefined &&
                                item.create_info.open_id !== ''
                              "
                            >
                              <span
                                :id="`popover-target-${index}`"
                                class="avatar-title rounded-circle bg-soft-primary text-primary"
                                >{{ onSpiltName(item.create_info.name) }}</span
                              >
                              <b-popover
                                variant="info"
                                :target="`popover-target-${index}`"
                                triggers="hover"
                                placement="top"
                              >
                                <template #title>{{
                                  item.create_info.name
                                }}</template>
                                OpenId <b>{{ item.create_info.open_id }}</b>
                                <!-- <br />
                                Employeeid <b>20000003</b> -->
                              </b-popover>
                            </div>
                          </div>
                          <div class="media-body">
                            <div class="media-body overflow-hidden">
                              <h6 class="text-truncate mb-1"></h6>
                            </div>
                            <span
                              class="badge badge-pill font-size-12"
                              :class="
                                item.action === 'Created'
                                  ? 'badge-soft-success'
                                  : 'badge-soft-warning'
                              "
                            >
                              {{ item.action }}
                            </span>
                            <div class="font-size-11 text-right">
                              {{ getTimeStr(item.create_info.time_stamp) }}
                            </div>
                          </div>
                        </div>
                      <!-- </a> -->
                    </li>
                  </template>
                </ul>
              </simplebar>
              <b-skeleton-table
                v-else
                :rows="10"
                :columns="1"
                :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>
          </b-card-text>
        </b-card>
      </div>
    </div>
    <div class="w-100 user-chat">
      <div class="col-md-12 card">
        <div class="p-4 border-bottom">
          <div v-show="viewDeferrenceLog.length > 0" class="row">
            <div class="col-md-8"></div>
            <div class="col-md-4">
              <ul class="list-inline user-chat-nav text-right mb-0">
                <li class="list-inline-item d-none d-sm-inline-block">
                  <b-form-checkbox
                    class="custom-checkbox-success mb-3"
                    switch
                    v-model="isShowOnlyChanged"
                    size="sm"
                    >Show only change</b-form-checkbox
                  >
                </li>
              </ul>
            </div>
          </div>
          <div v-if="isHeaderApproval" class="row">
            <div class="col-md-12">
              <b-card
                header-class="bg-transparent border-primary"
                class="border border-primary"
              >
                <template v-slot:header>
                  <h5 class="my-0 text-primary">
                    <i class="mdi mdi-bullseye-arrow mr-3"></i>
                    {{defaultLog.type }} Id: {{ defaultLog.reference_id }}
                  </h5>
                </template>
                <div class="text-center">
                  <div class="row">
                    <div class="col-sm-4">
                      <div>
                        <p class="text-muted mb-2">Topic</p>
                        <h5 class="font-size-12">{{ defaultLog.type }}</h5>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="mt-4 mt-sm-0">
                        <p class="text-muted mb-2">Date</p>
                        <h5 v-if="defaultLog.create_info !== undefined" class="font-size-12">
                          {{ getFullDateStr(defaultLog.create_info.time_stamp) }}
                        </h5>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="mt-4 mt-sm-0">
                        <p class="text-muted mb-2">Modified by</p>
                        <h5 v-if="defaultLog.create_info !== undefined" class="font-size-12">
                          {{ defaultLog.create_info.name }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div v-if="viewDeferrenceLog.length > 0" class="col-md-12 chat-users">
              <div class="chat-conversation p-3">
                <table class="table table-sm m-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Field</th>
                      <th>Origin</th>
                      <th>New</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in documentLogs" :key="item.id">
                      <th scope="row">{{ ++index }}</th>
                      <td>{{ item.key }}</td>
                      <td>
                        <span
                          v-show="item.original_log_value !== null"
                          class="badge badge-pill font-size-12"
                          :class="item.is_change ? `badge-soft-danger` : `badge-soft-secondary`"
                        >
                          {{ item.original_log_value }}
                        </span>
                      </td>
                      <td>
                        <span
                          v-show="item.new_log_value !== null"
                          class="badge badge-pill font-size-12"
                          :class="item.is_change ? `badge-soft-success` : `badge-soft-secondary`"
                        >
                          {{ item.new_log_value }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <template v-else>
              <b-card class="col-md-12 chat-users">
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
              </b-card>
              <b-skeleton-table
                :rows="5"
                :columns="4"
                :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import simplebar from "simplebar-vue";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import documentLogService from "@/helpers/service/document-log-provider";

export default {
  components: {
    simplebar,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.logsModel;
      },
    },
    // isShowOnlyChanged: {
    //   type: Boolean,
    //   default: () => {
    //     return false;
    //   },
    // },
  },
  data() {
    return {
      isShowOnlyChanged: false,
      defaultLog: null,
      logsModel: {
        logs: [],
        logTopic: "",
        referenceId: "",
      },
      viewDeferrenceLog: [],
    };
  },
  watch: {
    value: { 
      handler: async function () {
        await this.onChangeLogDetail(0);
      },
      deep: true
    }
  },
  computed: {
    documentLogs() {
      return this.isShowOnlyChanged 
              ? this.viewDeferrenceLog.filter( q => q.is_change) 
              : this.viewDeferrenceLog
    },
    isHeaderApproval() {
      return this.defaultLog !== null 
              && this.viewDeferrenceLog.length > 0
    }
  },
  async mounted() {
    await this.onChangeLogDetail(0);
  },
  methods: {
    async onChangeLogDetail(index) {
      this.viewDeferrenceLog = []

      if (this.value.logs[index] !== undefined) {
        this.defaultLog = this.value.logs[index];
        // console.log(this.defaultLog)
        this.defaultLog.create_info.name = this.defaultLog.create_info.name !== "" 
                                          ? this.defaultLog.create_info.name 
                                          : "-"
        await this.onSelectLogView(index);
      }
    },
    async onSelectLogView(index) {
      var _this = this;
      var newItemLog = this.value.logs[index];
      //console.log('xx', index + 1, this.value.logs.length);
      if (index < this.value.logs.length) {
        var originalLog = this.value.logs[index + 1];
        // console.log("newItemLog", newItemLog.id);
        // console.log("originalLog", originalLog.id);
        let params = new URLSearchParams();
        params.append("new_log_id", newItemLog.id);
        if (index + 1 < this.value.logs.length)
          params.append("original_log_id", originalLog.id);
          
        let result = await documentLogService.getDocumentLogsCompareAsync(
          _this.value.referenceId,
          _this.value.logTopic,
          params
        );
        
        if (result.status === 200) {
          this.viewDeferrenceLog = result.data;
        } else if (result.response.status === 404) {
          console.log("error", result.response.data.message);
        }
      }
    },
    onSpiltName(name) {
      // console.log('name', name);
      return name !== "" ? 
              `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`
              : "-"
    },
    getTimeStr(dateText) {
      var d = new Date(dateText);
      return moment(d).format("HH:MM:ss");
    },
    getDateStr(dateText) {
      var d = new Date(dateText);
      return moment(d).format("DD MMM yy");
    },
    getFullDateStr(dateText) {
      var d = new Date(dateText);
      return moment(d).format("DD MMM yy HH:MM:ss");
    },
  }
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.bg-active-hover:hover {
    background-color: aliceblue;
}
.verti-timeline .event-list {
    position: relative;
    padding: 20px 0px 20px 30px;
}
.verti-timeline .event-list .event-timeline-dot {
    top: 18px;
}
</style>
